export default "__VITE_PUBLIC_ASSET__36e9db0e__"